import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { WorkflowRtUiDurationBadgeModule } from '../duration-badge/workflow-rt-ui-duration-badge.module';
import { CareTableComponent } from './care-table.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [CareTableComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    WorkflowRtUiDurationBadgeModule,
    MatTooltipModule,
  ],
  exports: [CareTableComponent],
})
export class CareTableModule {}
